module.exports = __webpack_public_path__ + "img/2f_l_tomatsu@2x.7e2c70e1.png";